var _path, _path2, _path3, _path4, _path5, _path6, _line, _line2, _line3, _circle, _circle2, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExamination(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 71,
    viewBox: "0 0 77 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M41.4874 10.8364C36.6559 11.9057 32.6066 14.348 30.1382 18.0952C28.1075 21.1783 26.9203 24.752 24.0201 27.3653C20.9304 30.149 18.4234 31.6065 14.0545 32.0381C-1.87688 33.6126 -1.24173 56.1987 13.6622 65.1886C28.5661 74.1784 60.7276 72.9883 70.01 46.9508C79.2925 20.9134 65.697 13.8335 54.5185 11.0243C50.4503 10.0017 45.7658 9.88947 41.4874 10.8364Z",
    fill: "#E7EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1645 11.5078C55.4531 11.9558 59.6099 15.0174 59.6099 26.3924V41.3269C59.6099 51.2831 57.1208 56.2613 44.6755 56.2613H29.7411C17.2957 56.2613 14.8066 51.2831 14.8066 41.3269V26.3924C14.8066 15.0423 18.9634 11.9558 27.252 11.5078",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1645 11.5078C55.4531 11.9558 59.6099 15.0174 59.6099 26.3924V41.3269C59.6099 51.2831 57.1208 56.2613 44.6755 56.2613H29.7411C17.2957 56.2613 14.8066 51.2831 14.8066 41.3269V26.3924C14.8066 15.0423 18.9634 11.9558 27.252 11.5078",
    stroke: "#081E54",
    strokeWidth: 1.8668,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2301 16.4336H42.1864C47.1645 16.4336 47.1645 14.8779 47.1645 13.3223C47.1645 10.2109 44.6754 10.2109 42.1864 10.2109H32.2301C29.741 10.2109 27.252 10.2109 27.252 13.3223C27.252 16.4336 29.741 16.4336 32.2301 16.4336Z",
    fill: "#E0F3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5137 42.5742L34.2473 46.3078L44.2035 36.3516",
    stroke: "#1552E8",
    strokeWidth: 3.11134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2301 16.4406H42.1864C47.1645 16.4406 47.1645 13.9516 47.1645 11.4625C47.1645 6.48438 44.6754 6.48438 42.1864 6.48438H32.2301C29.741 6.48438 27.252 6.48438 27.252 11.4625C27.252 16.4406 29.741 16.4406 32.2301 16.4406Z",
    stroke: "#081E54",
    strokeWidth: 1.8668,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25.384,
    y1: 23.2762,
    x2: 49.0301,
    y2: 23.2762,
    stroke: "#A020FF",
    strokeWidth: 1.24453,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.384,
    y1: 27.0105,
    x2: 49.0301,
    y2: 27.0105,
    stroke: "#A020FF",
    strokeWidth: 1.24453,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 25.384,
    y1: 30.7449,
    x2: 49.0301,
    y2: 30.7449,
    stroke: "#A020FF",
    strokeWidth: 1.24453,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.67619,
    cy: 34.4262,
    r: 1.45921,
    stroke: "#081E54",
    strokeWidth: 0.621453
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.8543,
    cy: 20.3425,
    r: 2.93025,
    stroke: "#081E54",
    strokeWidth: 0.621453
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6159 34.3617C69.6159 34.0497 69.8673 33.7969 70.1776 33.7969L75.0086 33.7969C75.3189 33.7969 75.5703 34.0497 75.5703 34.3617C75.5703 34.6737 75.3189 34.9265 75.0086 34.9265L70.1776 34.9265C69.8673 34.9265 69.6159 34.6737 69.6159 34.3617Z",
    fill: "#3A6EEC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0348 36.7899L72.0348 31.932C72.0348 31.62 72.2862 31.3672 72.5965 31.3672C72.9068 31.3672 73.1582 31.62 73.1582 31.932L73.1582 36.7899C73.1582 37.1019 72.9068 37.3547 72.5965 37.3547C72.2862 37.3547 72.0348 37.1019 72.0348 36.7899Z",
    fill: "#3A6EEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamination);
export default __webpack_public_path__ + "static/media/Examination.1cdad8a64dcdccdabc9c30fc7d3abe71.svg";
export { ForwardRef as ReactComponent };